import { render, staticRenderFns } from "./footerSection.vue?vue&type=template&id=6d4d5d49&scoped=true&"
import script from "./footerSection.vue?vue&type=script&lang=js&"
export * from "./footerSection.vue?vue&type=script&lang=js&"
import style0 from "./footerSection.vue?vue&type=style&index=0&id=6d4d5d49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d5d49",
  null
  
)

export default component.exports